import type {Document} from '@contentful/rich-text-types'
import {Box, Grid, SectionIntro} from '@primer/react-brand/esm'
import type {Link} from '../../types'
import {renderWithoutParagraphs} from '../../utils'

type FlexSuiteSectionIntroProps = {
  heading?: Document
  label?: string
  description?: Document
  link?: Link
  constrainWidth?: boolean
}

export function FlexSuiteSectionIntro({
  heading,
  label,
  description,
  link,
  constrainWidth = false,
}: FlexSuiteSectionIntroProps) {
  if (!heading && !label && !description && !link) return null

  return (
    <Box paddingBlockStart={{narrow: 'spacious', regular: 64}} paddingBlockEnd={{narrow: 'spacious', regular: 64}}>
      <Grid>
        <Grid.Column span={constrainWidth ? {large: 6} : undefined} start={constrainWidth ? {large: 4} : undefined}>
          <SectionIntro align="center" fullWidth>
            {label ? <SectionIntro.Label>{label}</SectionIntro.Label> : null}
            {heading ? <SectionIntro.Heading size="3">{renderWithoutParagraphs(heading)}</SectionIntro.Heading> : null}
            {description ? (
              <SectionIntro.Description>{renderWithoutParagraphs(description)}</SectionIntro.Description>
            ) : null}
            {link?.fields.href ? (
              <SectionIntro.Link href={link.fields.href}>{link.fields.text}</SectionIntro.Link>
            ) : null}
          </SectionIntro>
        </Grid.Column>
      </Grid>
    </Box>
  )
}
